/**
 * Firebase phone proof in the browser (DREAMTREE-MULTITENANT-KNOWLEDGE §5.5): the company's
 * PUBLIC Firebase config (from company resolve) drives invisible reCAPTCHA + SMS; the ID
 * token goes to our server, which verifies it, and we sign out of Firebase straight away —
 * Firebase is never the app session.
 *
 * The SDK is loaded from Google's CDN only when a company actually uses Firebase, so the
 * bundle carries no Firebase code for everyone else.
 */

const SDK = 'https://www.gstatic.com/firebasejs/10.12.2';

async function sdk() {
  const [app, auth] = await Promise.all([
    import(/* @vite-ignore */ `${SDK}/firebase-app.js`),
    import(/* @vite-ignore */ `${SDK}/firebase-auth.js`),
  ]);
  return { app, auth };
}

function appFor(appMod, config) {
  // Named per project, so two companies' configs in one tab never share an app.
  const name = `aab-${config.projectId}`;
  const existing = appMod.getApps().find((a) => a.name === name);
  return existing || appMod.initializeApp(config, name);
}

/**
 * Send the SMS. `containerId` names an element for the invisible reCAPTCHA.
 * Returns `confirm(code) → idToken`.
 */
export async function sendPhoneCode(config, phone, containerId) {
  const { app: appMod, auth: authMod } = await sdk();
  const auth = authMod.getAuth(appFor(appMod, config));
  const verifier = new authMod.RecaptchaVerifier(auth, containerId, { size: 'invisible' });
  const confirmation = await authMod.signInWithPhoneNumber(auth, phone, verifier);
  return async function confirm(code) {
    const credential = await confirmation.confirm(code);
    const idToken = await credential.user.getIdToken();
    await authMod.signOut(auth).catch(() => {});
    verifier.clear();
    return idToken;
  };
}
